import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import numeral from 'numeral';
import { BiData } from '@wix/da-bi/pkg/events';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { getFragmentsBalance } from '../../../../publicSession/selectors';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';
import SuffixText from '../_partials/SuffixText';
import userMenuStyles from '../UserMenuDesktop/UserMenuDesktop.scss';
export function useFragmentsBalanceItem() {
    const { t } = useTranslation();
    const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
    const isMobile = useContext(MobileContext);
    const fragmentsBalance = useSelector(getFragmentsBalance);
    return {
        label: t('siteHeader.userMenu.fragmentsBalance'),
        suffix: /*#__PURE__*/ React.createElement(SuffixText, null, numeral(fragmentsBalance).format('0,0')),
        link: 'https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments',
        target: '_blank',
        className: isMobile ? undefined : userMenuStyles['fragments-link'],
        biData: BiData({
            evid: 702,
            link_url: 'https://www.deviantartsupport.com/en/article/what-are-badges-and-fragments',
            menu_item: 'fragments',
            menu_name: 'profile'
        }),
        tabIndex: isUserMenuOpen || !isMobile ? 0 : -1
    };
}

//# sourceMappingURL=useFragmentsBalanceItem.js.map